module.exports = __webpack_public_path__ + "static/media/TeamMembersAvatars.c039d8df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OnBoarding/Steps/assets/TeamMembersAvatars.svg
// module id = 928
// module chunks = 0